
import breakpointMixin from '~/mixins/breakpoints'
import StoryblokComponent from '~/components/Storyblok/Component'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.background = this.blok?.backgroundColor
      styles.borderRadius = this.getBreakpointValue(this.blok?.borderRadius)

      return styles
    },
    titleStyles() {
      const styles = {}

      styles.color = this.blok?.titleColor

      return styles
    },
    priceStyles() {
      const styles = {}

      styles.color = this.blok?.priceColor

      return styles
    },
    priceDetailsStyles() {
      const styles = {}

      styles.color = this.blok?.priceDetailsColor

      return styles
    },
    priceSuffixStyles() {
      const styles = {}

      styles.color = this.blok?.priceSuffixColor
      styles.fontSize = '1.5rem'

      return styles
    },
    bodyStyles() {
      const styles = {}

      styles.padding = this.getBreakpointValue(this.blok?.bodyPadding)

      return styles
    },
  },
}
